import { matchRoutes } from 'react-router-config'

import { convertToCommonLocation } from '.'
import getCurrentSiteByUrl from '../../../server/lib/getCurrentSiteByUrl'
import { IRouteConfig, PageType } from '../../../typings/routes'
import { hasFeature } from '../features'
import { IQuery } from './types'

// read the page type from routes config
export const getPageTypeFromURL = async (parsedLocation: Location | URL) => {
  try {
    const currentSite = getCurrentSiteByUrl(parsedLocation.hostname)
    const location = convertToCommonLocation(parsedLocation)
    const newRoutesEnabled = hasFeature('routes:new', currentSite, location)

    // HACKS: Have to async import these routes because of issues with circular dependencies (we think)
    const { newRoutes, oldRoutes } = await import('../../../common/routes')

    // figure out which route the current site is using
    const routes = newRoutesEnabled ? newRoutes : oldRoutes
    // parse url with route
    const matchedRouter = matchRoutes<IQuery>(routes, location.pathname)
    const pageLevelMatchedRouter = matchedRouter[matchedRouter.length - 1]
    return (pageLevelMatchedRouter.route as IRouteConfig).pageType
  } catch (e) {
    return PageType.OTHER
  }
}
